(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["limited-time-sale-collections"] && !Shopify.designMode) return;
  try {
    
      function sortTomoSaleCollections(section) {
        const grid =
    section.querySelector('.limited-time-sale-collections__grid');
        if (!grid) return;
        const today = new Date().toISOString().slice(0, 10);
        const dailyScore = (value) => {
          const input = `${today}:${value}`;
          let hash = 0;
          for (let i = 0; i < input.length; i += 1) {
            hash = (hash << 5) - hash + input.charCodeAt(i);
            hash |= 0;
          }
          return Math.abs(hash);
        };
        Array.from(grid.querySelectorAll('[data-tomo-sale-card]'))
          .sort((a, b) => {
            const order = section.dataset.tomoSaleSortOrder || 'ending_latest';
            if (order === 'random') return Math.random() - 0.5;
            if (order === 'daily_random') {
              const ak = a.dataset.saleCardKey || a.dataset.saleEndsAtTimestamp || '';
              const bk = b.dataset.saleCardKey || b.dataset.saleEndsAtTimestamp || '';
              return dailyScore(ak) - dailyScore(bk);
            }
            const ea = Number(a.dataset.saleEndsAtTimestamp) || 0;
            const eb = Number(b.dataset.saleEndsAtTimestamp) || 0;
            return order === 'ending_soon' ? ea - eb : eb - ea;
          })
          .forEach((card) => grid.appendChild(card));
      }

      function updateCarouselControls(section) {
        const c = section.querySelector('[data-tomo-sale-carousel]');
        const controls =
    section.querySelector('.limited-time-sale-collections__controls');
        const prev = section.querySelector('[data-tomo-sale-carousel-prev]');
        const next = section.querySelector('[data-tomo-sale-carousel-next]');
        if (!c || !controls || !prev || !next) return;
        const maxScroll = c.scrollWidth - c.clientWidth;
        controls.hidden = maxScroll <= 2;
        prev.disabled = c.scrollLeft <= 2;
        next.disabled = c.scrollLeft >= maxScroll - 2;
      }

      function tickCountdown(cd) {
        if (typeof cd.tick !== 'function') return false;
        const r = cd.tick();
        return r !== false && cd.isConnected && !cd.hidden;
      }

      function restartCountdowns(section) {
        window.tomoSaleCountdownIntervals = window.tomoSaleCountdownIntervals ||
    new WeakMap();
        section.querySelectorAll('tomo-sale-countdown').forEach((cd) => {
          if (window.tomoSaleCountdownIntervals.has(cd)) return;
          if (!tickCountdown(cd)) return;
          const i = window.setInterval(() => {
            if (tickCountdown(cd)) return;
            window.clearInterval(i);
            window.tomoSaleCountdownIntervals.delete(cd);
          }, 1000);
          window.tomoSaleCountdownIntervals.set(cd, i);
        });
      }

      function scrollCarousel(section, dir) {
        const c = section.querySelector('[data-tomo-sale-carousel]');
        if (!c) return;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        c.scrollBy({ left: c.clientWidth * dir * 0.9, behavior: reduced ? 'auto' :
     'smooth' });
      }

      function initSection(section) {
        sortTomoSaleCollections(section);
        restartCountdowns(section);
        updateCarouselControls(section);
        if (section.dataset.tomoSaleCarouselInitialized === 'true') return;
        section.dataset.tomoSaleCarouselInitialized = 'true';
        const prev = section.querySelector('[data-tomo-sale-carousel-prev]');
        const next = section.querySelector('[data-tomo-sale-carousel-next]');
        const c = section.querySelector('[data-tomo-sale-carousel]');
        prev?.addEventListener('click', () => scrollCarousel(section, -1));
        next?.addEventListener('click', () => scrollCarousel(section, 1));
        c?.addEventListener('scroll', () => updateCarouselControls(section), {
    passive: true });
        window.addEventListener('resize', () => updateCarouselControls(section));
      }

      function initAll() {

    document.querySelectorAll('[data-tomo-sale-section]').forEach(initSection);
      }

      initAll();
      document.addEventListener('DOMContentLoaded', initAll);
      document.addEventListener('shopify:section:load', (e) => {

    e.target.querySelectorAll('[data-tomo-sale-section]').forEach(initSection);
      });
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ltd-sale-coll"] && !Shopify.designMode) return;
  try {
    
  function sortTomoSaleCollections(section) {
    const grid = section.querySelector('.limited-time-sale-collections__grid');
    if (!grid) return;
    const today = new Date().toISOString().slice(0, 10);
    const dailyScore = (value) => {
      const input = `${today}:${value}`;
      let hash = 0;
      for (let i = 0; i < input.length; i += 1) {
        hash = (hash << 5) - hash + input.charCodeAt(i);
        hash |= 0;
      }
      return Math.abs(hash);
    };
    Array.from(grid.querySelectorAll('[data-tomo-sale-sort-item]'))
      .sort((a, b) => {
        const order = section.dataset.tomoSaleSortOrder || 'oldest_first';
        if (order === 'random') return Math.random() - 0.5;
        if (order === 'daily_random') {
          const ak = a.dataset.saleCardKey || a.dataset.saleEndsAtTimestamp || '';
          const bk = b.dataset.saleCardKey || b.dataset.saleEndsAtTimestamp || '';
          return dailyScore(ak) - dailyScore(bk);
        }
        const sa = Number(a.dataset.saleStartsAtTimestamp) || 0;
        const sb = Number(b.dataset.saleStartsAtTimestamp) || 0;
        const ea = Number(a.dataset.saleEndsAtTimestamp) || 0;
        const eb = Number(b.dataset.saleEndsAtTimestamp) || 0;
        if (order === 'newest_first') return sb - sa;
        if (order === 'ending_soon') return ea - eb;
        if (order === 'ending_latest') return eb - ea;
        return sa - sb;
      })
      .forEach((card) => grid.appendChild(card));
  }

  function updateCarouselControls(section) {
    const c = section.querySelector('[data-tomo-sale-carousel]');
    const controls = section.querySelector('.limited-time-sale-collections__controls');
    const prev = section.querySelector('[data-tomo-sale-carousel-prev]');
    const next = section.querySelector('[data-tomo-sale-carousel-next]');
    if (!c || !controls || !prev || !next) return;
    const maxScroll = c.scrollWidth - c.clientWidth;
    controls.hidden = maxScroll <= 2;
    prev.disabled = c.scrollLeft <= 2;
    next.disabled = c.scrollLeft >= maxScroll - 2;
  }

  function tickCountdown(cd) {
    if (typeof cd.tick !== 'function') return false;
    const r = cd.tick();
    return r !== false && cd.isConnected && !cd.hidden;
  }

  function restartCountdowns(section) {
    window.tomoSaleCountdownIntervals = window.tomoSaleCountdownIntervals || new WeakMap();
    section.querySelectorAll('tomo-sale-countdown').forEach((cd) => {
      if (window.tomoSaleCountdownIntervals.has(cd)) return;
      if (!tickCountdown(cd)) return;
      const i = window.setInterval(() => {
        if (tickCountdown(cd)) return;
        window.clearInterval(i);
        window.tomoSaleCountdownIntervals.delete(cd);
      }, 1000);
      window.tomoSaleCountdownIntervals.set(cd, i);
    });
  }

  function scrollCarousel(section, dir) {
    const c = section.querySelector('[data-tomo-sale-carousel]');
    if (!c) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    c.scrollBy({ left: c.clientWidth * dir * 0.9, behavior: reduced ? 'auto' : 'smooth' });
  }

  function initSection(section) {
    sortTomoSaleCollections(section);
    restartCountdowns(section);
    updateCarouselControls(section);
    if (section.dataset.tomoSaleCarouselInitialized === 'true') return;
    section.dataset.tomoSaleCarouselInitialized = 'true';
    const prev = section.querySelector('[data-tomo-sale-carousel-prev]');
    const next = section.querySelector('[data-tomo-sale-carousel-next]');
    const c = section.querySelector('[data-tomo-sale-carousel]');
    prev?.addEventListener('click', () => scrollCarousel(section, -1));
    next?.addEventListener('click', () => scrollCarousel(section, 1));
    c?.addEventListener('scroll', () => updateCarouselControls(section), { passive: true });
    window.addEventListener('resize', () => updateCarouselControls(section));
  }

  function initAll() {
    document.querySelectorAll('[data-tomo-sale-section]').forEach(initSection);
  }

  initAll();
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('[data-tomo-sale-section]').forEach(initSection);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-flash-v3"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) card.scrollIntoView({ behavior: 'instant' });
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sw-shop-all-sales"] && !Shopify.designMode) return;
  try {
    
    function sortTomoSaleCollections(section) {
      const grid =
  section.querySelector('.limited-time-sale-collections__grid');
      if (!grid) return;
      const today = new Date().toISOString().slice(0, 10);
      const dailyScore = (value) => {
        const input = `${today}:${value}`;
        let hash = 0;
        for (let i = 0; i < input.length; i += 1) {
          hash = (hash << 5) - hash + input.charCodeAt(i);
          hash |= 0;
        }
        return Math.abs(hash);
      };
      Array.from(grid.querySelectorAll('[data-tomo-sale-card]'))
        .sort((a, b) => {
          const order = section.dataset.tomoSaleSortOrder || 'ending_latest';
          if (order === 'random') return Math.random() - 0.5;
          if (order === 'daily_random') {
            const ak = a.dataset.saleCardKey || a.dataset.saleEndsAtTimestamp || '';
            const bk = b.dataset.saleCardKey || b.dataset.saleEndsAtTimestamp || '';
            return dailyScore(ak) - dailyScore(bk);
          }
          const ea = Number(a.dataset.saleEndsAtTimestamp) || 0;
          const eb = Number(b.dataset.saleEndsAtTimestamp) || 0;
          return order === 'ending_soon' ? ea - eb : eb - ea;
        })
        .forEach((card) => grid.appendChild(card));
    }

    function updateCarouselControls(section) {
      const c = section.querySelector('[data-tomo-sale-carousel]');
      const controls =
  section.querySelector('.limited-time-sale-collections__controls');
      const prev = section.querySelector('[data-tomo-sale-carousel-prev]');
      const next = section.querySelector('[data-tomo-sale-carousel-next]');
      if (!c || !controls || !prev || !next) return;
      const maxScroll = c.scrollWidth - c.clientWidth;
      controls.hidden = maxScroll <= 2;
      prev.disabled = c.scrollLeft <= 2;
      next.disabled = c.scrollLeft >= maxScroll - 2;
    }

    function tickCountdown(cd) {
      if (typeof cd.tick !== 'function') return false;
      const r = cd.tick();
      return r !== false && cd.isConnected && !cd.hidden;
    }

    function restartCountdowns(section) {
      window.tomoSaleCountdownIntervals = window.tomoSaleCountdownIntervals ||
  new WeakMap();
      section.querySelectorAll('tomo-sale-countdown').forEach((cd) => {
        if (window.tomoSaleCountdownIntervals.has(cd)) return;
        if (!tickCountdown(cd)) return;
        const i = window.setInterval(() => {
          if (tickCountdown(cd)) return;
          window.clearInterval(i);
          window.tomoSaleCountdownIntervals.delete(cd);
        }, 1000);
        window.tomoSaleCountdownIntervals.set(cd, i);
      });
    }

    function initLoadMore(section) {
      const grid = section.querySelector('.limited-time-sale-collections__grid');
      const wrap = section.querySelector('[data-tomo-sale-loadmore-wrap]');
      const button = section.querySelector('[data-tomo-sale-loadmore]');
      if (!grid || !wrap || !button) return;

      const step = Number(section.dataset.tomoSaleInitialVisible) || 50;
      let visible = step;

      function applyVisibility() {
        const cards = Array.from(grid.querySelectorAll('[data-tomo-sale-card]'));
        cards.forEach((card, index) => {
          card.hidden = index >= visible;
        });
        wrap.hidden = visible >= cards.length;
      }

      if (section.dataset.tomoSaleLoadMoreInitialized !== 'true') {
        section.dataset.tomoSaleLoadMoreInitialized = 'true';
        button.addEventListener('click', () => {
          visible += step;
          applyVisibility();
          restartCountdowns(section);
        });
      }

      applyVisibility();
    }

    function scrollCarousel(section, dir) {
      const c = section.querySelector('[data-tomo-sale-carousel]');
      if (!c) return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      c.scrollBy({ left: c.clientWidth * dir * 0.9, behavior: reduced ? 'auto' :
   'smooth' });
    }

    function initSection(section) {
      sortTomoSaleCollections(section);
      initLoadMore(section);
      restartCountdowns(section);
      updateCarouselControls(section);
      if (section.dataset.tomoSaleCarouselInitialized === 'true') return;
      section.dataset.tomoSaleCarouselInitialized = 'true';
      const prev = section.querySelector('[data-tomo-sale-carousel-prev]');
      const next = section.querySelector('[data-tomo-sale-carousel-next]');
      const c = section.querySelector('[data-tomo-sale-carousel]');
      prev?.addEventListener('click', () => scrollCarousel(section, -1));
      next?.addEventListener('click', () => scrollCarousel(section, 1));
      c?.addEventListener('scroll', () => updateCarouselControls(section), {
  passive: true });
      window.addEventListener('resize', () => updateCarouselControls(section));
    }

    function initAll() {
  
  document.querySelectorAll('[data-tomo-sale-section]').forEach(initSection);
    }

    initAll();
    document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', (e) => {
  
  e.target.querySelectorAll('[data-tomo-sale-section]').forEach(initSection);
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tomo-404-timed-fallback"]) return;
  try {
    
  (() => {
    const fallback = document.getElementById('tomo-404-timed-fallback');
    if (!fallback) return;

    const saleSection = document.querySelector('[data-tomo-sale-section]');

    const syncFallback = () => {
      const hasVisibleCard = saleSection && !saleSection.hidden && saleSection.querySelector('[data-tomo-sale-card]:not([hidden])');
      const shouldHideFallback = Boolean(hasVisibleCard);
      if (fallback.hidden !== shouldHideFallback) fallback.hidden = shouldHideFallback;
    };

    syncFallback();
    if (saleSection) {
      new MutationObserver(syncFallback).observe(saleSection, {
        subtree: true,
        attributes: true,
        attributeFilter: ['hidden'],
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tomo-combined"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tomo-combined')) {
  customElements.define('tomo-combined', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.classList.add('tc-enhanced');
      this.previewThemeId = window.Shopify?.theme?.role !== 'main' ? window.Shopify?.theme?.id : null;
      this.feedUrl = this.normalizeUrl(new URL(window.location.href));
      this.refreshControls();
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-tc-sort]')) return;
        const url = new URL(this.feedUrl);
        url.searchParams.set('sort_by', event.target.value);
        url.searchParams.delete('page');
        this.loadResults(url);
      });
      this.addEventListener('input', event => {
        if (!event.target.matches('[data-tc-search] input[name="q"]')) return;
        if (event.target.value.trim()) {
          this.requestController?.abort();
          this.loading = false;
          this.querySelector('[data-tc-status]').textContent = '';
          this.querySelector('[data-tc-results]').removeAttribute('aria-busy');
          const more = this.querySelector('[data-tc-more]');
          if (more) more.disabled = false;
        } else if (this.querySelector('.tc-shop').dataset.mode === 'search') this.showAll(true);
      });
      this.addEventListener('submit', event => {
        const form = event.target;
        if (!form.matches('[data-tc-search], [data-tc-search-tools]')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (form.matches('[data-tc-search-tools]')) {
          const url = new URL(this.feedUrl);
          url.searchParams.set('sort_by', form.elements.sort_by.value);
          url.searchParams.delete('page');
          this.loadResults(url);
          return;
        }
        const terms = form.elements.q.value.replace(/&(?:amp;)?quot;/g, '"').replace(/^\(?tag:"99 or less"\)?\s+AND\s+/i, '').trim();
        if (!terms) { this.showAll(true); return; }
        const url = new URL(this.dataset.searchUrl, location.origin);
        url.searchParams.set('q', 'tag:"99 or less" AND (' + terms.replace(/[()]/g, ' ') + ')');
        url.searchParams.set('type', 'product');
        url.searchParams.set('sort_by', 'relevance');
        url.searchParams.set('filter.v.price.lte', this.priceLimit());
        this.loadResults(url, false, true);
      });
      this.addEventListener('click', event => {
        const more = event.target.closest('[data-tc-more]');
        if (more) {
          if (this.nextUrl) this.loadResults(new URL(this.nextUrl), true);
          return;
        }
        const link = event.target.closest('[data-tc-budget], [data-tc-nav]');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (link.hasAttribute('data-tc-all')) { this.showAll(); return; }
        const url = link.hasAttribute('data-tc-budget') ? new URL(this.feedUrl) : new URL(link.href);
        url.searchParams.delete('page');
        url.searchParams.set('filter.v.price.lte', link.dataset.tcBudget || this.priceLimit());
        this.loadResults(url);
      });
      this.addEventListener('submit', async event => {
        const form = event.target.closest('[data-tc-add]');
        if (!form) return;
        event.preventDefault();
        const button = form.querySelector('button');
        const feedback = form.querySelector('.tc-feedback');
        if (button.disabled) return;
        button.disabled = true;
        feedback.replaceChildren();
        try {
          const response = await fetch(form.action + '.js', {method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
          const item = await response.json();
          if (!response.ok) throw new Error(item.description || this.dataset.error);
          feedback.append(document.createTextNode(this.dataset.added + ' '));
          const cartLink = document.createElement('a');
          cartLink.href = this.dataset.cartUrl;
          cartLink.textContent = this.dataset.viewCart;
          feedback.append(cartLink);
          document.dispatchEvent(new CustomEvent('cart:update', {bubbles:true, detail:{data:{source:'product-form-component',productId:item.product_id}}}));
        } catch(error) { feedback.textContent = error.message || this.dataset.error; }
        finally { button.disabled = false; }
      });
    }
    disconnectedCallback() {
      this.requestController?.abort();
    }
    priceLimit() {
      return this.feedUrl.searchParams.get('filter.v.price.lte') || '99.99';
    }
    normalizeUrl(value) {
      const url = new URL(value);
      if (url.origin !== location.origin) throw new Error('Invalid sale URL');
      if (!url.pathname.includes('/search') && !url.pathname.includes('/collections/')) {
        url.pathname = this.querySelector('.tc-shop').dataset.feedUrl || this.dataset.allUrl;
      }
      url.searchParams.set('view', 'tomo-combined');
      if (this.previewThemeId) url.searchParams.set('preview_theme_id', String(this.previewThemeId));
      url.searchParams.set('filter.v.availability', '1');
      if (!url.searchParams.has('filter.v.price.lte')) url.searchParams.set('filter.v.price.lte', '99.99');
      url.searchParams.set('options[unavailable_products]', 'hide');
      url.hash = 'tc-shop';
      return url;
    }
    showAll(keepFocus = false) {
      const url = new URL(this.dataset.allUrl, location.origin);
      url.searchParams.set('filter.v.price.lte', this.priceLimit());
      this.loadResults(url, false, keepFocus);
    }
    filterSaleCards(shop, maximum) {
      for (const card of shop.querySelectorAll('[data-tc-results] .tc-card')) {
        const price = Number(card.dataset.salePrice);
        if (!Number.isFinite(price) || price <= 0 || price > maximum) card.remove();
      }
    }
    showCountProgress(key) {
      if (key !== this.currentCountKey || this.activeCount?.key !== key) return;
      const progress = this.activeCount.progress;
      const target = this.querySelector('[data-tc-total]');
      if (!progress || !target || target.hasAttribute('data-tc-initial-estimate')) return;
      const maximum = Number(this.priceLimit());
      const slot = maximum <= 25 ? 0 : maximum <= 50 ? 1 : maximum <= 75 ? 2 : 3;
      const count = progress[slot];
      target.textContent = count > 0 ? count.toLocaleString() + '+ available finds · total updating' : 'Available finds · total updating';
    }
    readStoredSaleCount(key) {
      // Persist collection totals only; shopper search terms stay in memory.
      if (new URL(key).searchParams.has('q')) return null;
      try {
        const entry = JSON.parse(localStorage.getItem('tomo-sale-counts-v1') || '{}')[key];
        if (!entry || !Number.isFinite(entry.at) || Date.now() - entry.at > 300000 ||
            entry.at > Date.now() || !Array.isArray(entry.counts) || entry.counts.length !== 4 ||
            entry.counts.some(n => !Number.isInteger(n) || n < 0 || n > 25000)) return null;
        entry.counts.capped = Boolean(entry.capped);
        return entry;
      } catch { return null; }
    }
    storeSaleCount(key, entry) {
      if (new URL(key).searchParams.has('q')) return;
      try {
        const saved = JSON.parse(localStorage.getItem('tomo-sale-counts-v1') || '{}');
        saved[key] = {at:entry.at, counts:[...entry.counts], capped:Boolean(entry.counts.capped)};
        const recent = Object.entries(saved).filter(([,item]) => Date.now() - item.at < 300000)
          .sort((a,b) => b[1].at - a[1].at).slice(0,8);
        localStorage.setItem('tomo-sale-counts-v1', JSON.stringify(Object.fromEntries(recent)));
      } catch { /* Browsing also works when storage is unavailable. */ }
    }
    async updateAvailableTotal() {
      const target = this.querySelector('[data-tc-total]');
      if (!target) return;
      const countUrl = new URL(this.feedUrl);
      for (const key of [...countUrl.searchParams.keys()]) {
        if (key.startsWith('filter.') || key === 'sort_by' || key === 'page' || key === 'options[unavailable_products]') countUrl.searchParams.delete(key);
      }
      countUrl.searchParams.set('view', 'tomo-sale-count');
      countUrl.hash = '';
      const key = countUrl.href;
      const maximum = Number(this.priceLimit());
      const slot = maximum <= 25 ? 0 : maximum <= 50 ? 1 : maximum <= 75 ? 2 : 3;
      const sequence = this.countSequence = (this.countSequence || 0) + 1;
      this.currentCountKey = key;
      target.textContent = target.dataset.tcInitialEstimate || 'Available finds';
      target.setAttribute('aria-live', 'off');
      this.saleCounts ||= new Map();
      try {
        let cached = this.saleCounts.get(key) || this.readStoredSaleCount(key);
        if (cached && Date.now() - cached.at > 300000) { this.saleCounts.delete(key); cached = null; }
        let counts = cached?.counts;
        if (!counts) {
          if (this.activeCount?.key !== key) {
            this.activeCount?.controller.abort();
            const controller = new AbortController();
            const promise = this.fetchAvailableCounts(countUrl, controller.signal, progress => {
              if (this.activeCount?.key !== key) return;
              this.activeCount.progress = progress;
              this.showCountProgress(key);
            });
            this.activeCount = {key, controller, promise};
          }
          this.showCountProgress(key);
          const active = this.activeCount;
          counts = await active.promise;
          if (this.activeCount === active) this.activeCount = null;
          const entry = {at:Date.now(), counts};
          this.saleCounts.set(key, entry);
          this.storeSaleCount(key, entry);
          if (this.saleCounts.size > 8) this.saleCounts.delete(this.saleCounts.keys().next().value);
        }
        if (sequence !== this.countSequence || !target.isConnected) return;
        target.removeAttribute('data-tc-initial-estimate');
        target.setAttribute('aria-live', 'polite');
        const count = counts[slot];
        target.textContent = (counts.capped ? 'At least ' : '') + count.toLocaleString() + (count === 1 ? ' available find' : ' available finds') + (counts.capped ? ' — narrow your search for an exact total.' : '');
      } catch (error) {
        if (sequence !== this.countSequence || !target.isConnected || error.name === 'AbortError') return;
        target.textContent = 'Total temporarily unavailable — you can still browse.';
        target.dataset.countError = error.message;
        if (this.activeCount?.key === key) this.activeCount = null;
      }
    }
    async fetchAvailableCounts(url, signal, onProgress = () => {}) {
      const readPage = async page => {
        const next = new URL(url);
        next.searchParams.set('page', String(page));
        const response = await fetch(next, {signal, credentials:'same-origin', priority:'low'});
        if (!response.ok) throw new Error('Count request failed');
        const data = JSON.parse(await response.text());
        if (data.page !== page || !Number.isInteger(data.pages) || data.pages < 0 ||
            !Number.isInteger(data.sourceCount) || data.sourceCount > 25000 ||
            !Array.isArray(data.counts) || data.counts.length !== 4 ||
            data.counts.some(n => !Number.isInteger(n) || n < 0 || n > 250)) throw new Error('Incomplete sale count');
        return data;
      };
      const first = await readPage(1);
      const counts = [...first.counts];
      counts.capped = Boolean(first.capped);
      onProgress([...counts]);
      let cursor = 2;
      // Small count-only responses; at most three requests concurrently.
      await Promise.all(Array.from({length:Math.max(0, Math.min(3, first.pages - 1))}, async () => {
        while (cursor <= first.pages) {
          const page = cursor++;
          const batch = await readPage(page);
          if (batch.pages !== first.pages || batch.sourceCount !== first.sourceCount) throw new Error('Sale changed while counting');
          batch.counts.forEach((n, i) => { counts[i] += n; });
          onProgress([...counts]);
        }
      }));
      return counts;
    }
    refreshControls() {
      const shop = this.querySelector('.tc-shop');
      const price = this.priceLimit();
      this.filterSaleCards(shop, Number(price) * 100);
      this.updateAvailableTotal();
      shop.querySelectorAll('[data-tc-budget]').forEach(link => {
        if (link.dataset.tcBudget === price) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      shop.querySelectorAll('.tc-pagination a').forEach(link => {
        const url = new URL(link.href);
        url.searchParams.set('view', 'tomo-combined');
        link.href = url;
      });
      this.nextUrl = shop.querySelector('.tc-pagination .next a')?.href || null;
      shop.querySelector('[data-tc-more]')?.remove();
      if (this.nextUrl) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'tc-more';
        button.dataset.tcMore = '';
        button.textContent = 'Load more finds';
        shop.querySelector('[data-tc-results]').append(button);
      }
      const empty = shop.querySelector('[data-tc-empty]');
      if (empty) {
        empty.hidden = Boolean(shop.querySelector('[data-tc-results] .tc-card')) || Boolean(this.nextUrl);
        if (!empty.hidden) empty.firstChild.textContent = 'No matching sale options in this category or search at the selected price. Try All sale prices, another category, or ';
      }
    }
    async loadResults(value, append = false, keepFocus = false) {
      if (append && this.loading) return;
      const url = this.normalizeUrl(value);
      this.requestController?.abort();
      const controller = new AbortController();
      this.requestController = controller;
      this.loading = true;
      const shop = this.querySelector('.tc-shop');
      const status = shop.querySelector('[data-tc-status]');
      status.textContent = 'Loading finds…';
      shop.querySelector('[data-tc-results]').setAttribute('aria-busy', 'true');
      const more = shop.querySelector('[data-tc-more]');
      if (more) more.disabled = true;
      try {
        // A Shopify page can contain only products excluded by the sale-card checks.
        // Advance empty batches before showing an empty state; cap work per action.
        let batchUrl = url;
        let doc;
        let next;
        const visited = new Set();
        for (let batch = 0; batch < 8; batch++) {
          if (visited.has(batchUrl.href)) throw new Error('Repeated results page');
          visited.add(batchUrl.href);
          const response = await fetch(batchUrl, {signal:controller.signal, credentials:'same-origin'});
          if (!response.ok) throw new Error('Unable to load finds');
          doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          next = doc.querySelector('tomo-combined .tc-shop');
          if (!next) throw new Error('Unable to load finds');
          this.filterSaleCards(next, Number(url.searchParams.get('filter.v.price.lte')) * 100);
          const nextLink = next.querySelector('.tc-pagination .next a');
          if (next.querySelector('[data-tc-results] .tc-card') || !nextLink) break;
          status.textContent = 'Checking more sale finds…';
          batchUrl = this.normalizeUrl(new URL(nextLink.getAttribute('href'), batchUrl));
        }
        if (controller.signal.aborted) return;
        let added = 0;
        if (append) {
          const grid = shop.querySelector('[data-tc-results] .tc-grid');
          const ids = new Set([...grid.querySelectorAll('.tc-card')].map(card => card.dataset.productId));
          for (const card of next.querySelectorAll('[data-tc-results] .tc-grid > .tc-card')) {
            if (ids.has(card.dataset.productId)) continue;
            ids.add(card.dataset.productId);
            grid.append(document.importNode(card, true));
            added++;
          }
          shop.querySelector('.tc-pagination').replaceWith(document.importNode(next.querySelector('.tc-pagination'), true));
        } else {
          shop.replaceWith(document.importNode(next, true));
          this.feedUrl = url;
          const oldPicks = this.querySelector('.tc-shortlist');
          const newPicks = doc.querySelector('tomo-combined .tc-shortlist');
          if (newPicks) {
            if (oldPicks) oldPicks.replaceWith(document.importNode(newPicks, true));
            else this.querySelector('.tc-shop').before(document.importNode(newPicks, true));
          } else oldPicks?.remove();
        }
        this.refreshControls();
        const currentShop = this.querySelector('.tc-shop');
        const count = currentShop.querySelectorAll('[data-tc-results] .tc-card').length;
        currentShop.querySelector('[data-tc-status]').textContent = count
          ? (append ? (added ? 'More finds loaded.' : 'All matching finds loaded.') : '')
          : (this.nextUrl ? 'Still checking this selection. Use Load more finds to continue.' : 'No matching finds for this selection.');
        if (keepFocus) currentShop.querySelector('[data-tc-search] input[name="q"]').focus({preventScroll:true});
        else if (append) currentShop.querySelector('[data-tc-more]')?.focus({preventScroll:true});
      } catch (error) {
        if (error.name !== 'AbortError') { status.textContent = 'Could not refresh results. Please try again.'; status.dataset.resultsError = error.message; }
      } finally {
        if (this.requestController === controller) {
          this.loading = false;
          this.querySelector('[data-tc-results]')?.removeAttribute('aria-busy');
          const button = this.querySelector('[data-tc-more]');
          if (button) button.disabled = false;
        }
      }
    }

  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tomo-homepage-live-sales"] && !Shopify.designMode) return;
  try {
    
  function sortTomoLiveSalesEndingSoon() {
    document.querySelectorAll('[data-tomo-live-sales-grid]').forEach((grid) => {
      Array.from(grid.querySelectorAll('.tomo-live-sales__card'))
        .sort((cardA, cardB) => {
          const endsAtA = Number(cardA.dataset.saleEndsAtTimestamp) || 0;
          const endsAtB = Number(cardB.dataset.saleEndsAtTimestamp) || 0;

          return endsAtA - endsAtB;
        })
        .forEach((card) => grid.appendChild(card));
    });
  }

  sortTomoLiveSalesEndingSoon();
  document.addEventListener('DOMContentLoaded', sortTomoLiveSalesEndingSoon);
  document.addEventListener('shopify:section:load', sortTomoLiveSalesEndingSoon);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tomo-sale-discovery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tomo-sale-discovery')) {
 class SaleDiscovery extends HTMLElement {
  connectedCallback() {
   if (this.ready) return; this.ready=true;
   this.bestsellerRanks=JSON.parse(this.querySelector('[data-sale-bestseller-ranks]')?.textContent||'{}');

   this.eveningOrder=JSON.parse(this.querySelector('[data-evening-order]')?.textContent||'[]');this.finalHourOrder=JSON.parse(this.querySelector('[data-final-hour-order]')?.textContent||'[]');this.collectionRanks=JSON.parse(this.querySelector('[data-collection-ranks]')?.textContent||'{}');this.editorialHome=[...this.querySelector('[data-editorial-view]').children];this.collectionOrder='tonight';this.querySelector('[data-collection-order]').addEventListener('change',e=>{this.collectionOrder=e.target.value;if(this.collectionOrder==='bestselling')this.state.layout='editorial';if(this.collectionOrder==='final-hours'){Object.assign(this.state,{day:'all',collection:'',category:'',brand:'',price:'',sort:'featured',search:'',low:false});this.browseExtra=0}this.orderCollections();this.apply();this.track('collection_sort',{sort:this.collectionOrder})});
   this.labels=JSON.parse(this.querySelector('[data-sale-labels]').textContent);
   this.rails=[...this.querySelectorAll('[data-sale-rail]')];this.cards=new Map();this.sources=[];
   this.state={layout:'catalog',day:'all',category:'',brand:'',price:'',sort:'featured',search:'',low:false,collection:''};this.limit=24;this.expanded=false;this.browseExtra=0;this.sourceTasks=new Map();this.seedPromise=null;this.sequence=0;this.busy=false;this.indexDone=false;this.railQueue=[];this.railWorkers=0;this.railRequests=new Map();this.requests=new Set();
   this.grid=this.querySelector('[data-sale-grid]');this.controls=[...this.querySelectorAll('[data-filter]')];
   this.rails.forEach(rail=>{
    const source={id:rail.dataset.id,url:rail.dataset.source,label:rail.dataset.label,category:rail.dataset.category,dates:rail.dataset.dates.split(',').map(v=>v.trim()).filter(Boolean),end:rail.dataset.expire,next:'',done:false,error:false,rank:this.sources.length,position:0,seeds:[]};
    source.next=source.url+'?view=tomo-sale-feed';this.sources.push(source);
    rail.querySelectorAll('[data-sale-card]').forEach(card=>{this.addCard(card,source);if(this.cards.has(card.dataset.campaignProductId))source.seeds.push(card.dataset.campaignProductId)});
    if (!rail.querySelector('[id="campaign-collection-'+source.id+'"]'))rail.id='campaign-collection-'+source.id;
   });
   this.rails.forEach((rail,i)=>this.prepareEditorialRail(rail,this.sources[i]));
   this.weekendProducts=this.querySelector('[data-weekend-products]');this.weekendHome=this.querySelector('[data-weekend-products-home]');if(this.weekendProducts){this.prepareProductRail(this.weekendProducts.querySelector('[data-weekend-products-rail]'),{label:this.labels.topProducts||'Best-selling items'},'weekend')}
   this.setupHero();
   const cats=[...new Set(this.sources.map(s=>s.category))].sort();const select=this.querySelector('[data-filter=category]');cats.forEach(c=>select.add(new Option(c,c)));
   this.railObserver=new IntersectionObserver(entries=>{if(this.state.layout==='editorial')entries.filter(e=>e.isIntersecting&&!e.target.hidden).forEach(e=>this.queueRail(e.target))},{rootMargin:'500px 0px'});this.rails.forEach(r=>this.railObserver.observe(r));this.readURL();this.buildDays();this.bind();this.apply(false);this.handleHash();
   this.clock=setInterval(()=>{this.buildDays();this.apply(false)},60000);
  }
  disconnectedCallback(){this.productRailObserver?.disconnect();this.railObserver?.disconnect();this.requests?.forEach(c=>c.abort());window.removeEventListener('scroll',this.scrollHandler);clearInterval(this.clock);this.abort?.abort();window.removeEventListener('popstate',this.pop);window.removeEventListener('hashchange',this.hashHandler);}
  setupHero(){
   this.heroGallery=this.querySelector('[data-hero-gallery]');if(!this.heroGallery)return;
   this.heroFeatured=[...this.heroGallery.children].map(n=>n.cloneNode(true));this.heroMode='featured';
   this.heroButtons=[...this.querySelectorAll('[data-hero-choice]')];
   this.heroButtons.forEach(b=>b.addEventListener('click',()=>{if(b.disabled||b.dataset.heroChoice===this.heroMode)return;this.heroMode=b.dataset.heroChoice;this.paintHero(true);this.track('hero_category',{category:this.heroMode})}));
   this.querySelector('[data-hero-choices]').hidden=false;this.refreshHeroChoices();
  }
  heroPicks(mode){
   if(mode==='featured')return this.heroFeatured.filter(n=>!n.dataset.expire||Date.now()<Date.parse(n.dataset.expire)).map(n=>n.cloneNode(true));
   const categories={designer:['Jewelry','Bags & Carry','Watches'],tech:['Tech'],home:['Home','Kitchen & Bar']};
   const picks=[],seen=new Set();
   const sources=this.sources.filter(source=>this.active(source)&&categories[mode]?.includes(source.category));
   for(let position=0;position<8;position++){for(const source of sources){
    const id=source.seeds[position];if(!id)continue;const card=this.cards.get(id);if(!card||seen.has(id))continue;
     const original=card.node,link=original.querySelector('.tomo-edit__product-link'),img=original.querySelector('.tomo-edit__product-image img'),price=original.querySelector('.tomo-edit__price');if(!link||!img||!price)continue;
     const a=document.createElement('a');a.className='sale-hero__item sale-hero__item--'+(picks.length+1);a.href=link.href;if(source.end)a.dataset.expire=source.end;
     const photo=img.cloneNode(true);photo.removeAttribute('id');photo.loading='eager';photo.sizes='(max-width:749px) 30vw, 25vw';a.append(photo);
     const title=document.createElement('span');title.className='sale-hero__title';title.textContent=card.title||original.querySelector('.tomo-edit__product-title')?.textContent||img.alt;a.append(title);
     const cost=document.createElement('span');cost.className='sale-hero__price';
     const amount=document.createElement('strong');const priceCopy=price.cloneNode(true);priceCopy.querySelectorAll('.tomo-edit__compare,s').forEach(n=>n.remove());amount.textContent=priceCopy.textContent.trim();cost.append(amount);
     const compare=price.querySelector('.tomo-edit__compare,s');if(compare){const s=document.createElement('s');s.textContent=compare.textContent;cost.append(s)}a.append(cost);
     const saving=original.querySelector('.sale-card__saving');if(card.saving>0&&saving){const s=document.createElement('span');s.className='sale-hero__saving';s.textContent=saving.textContent;a.append(s)}
     picks.push(a);seen.add(id);if(picks.length===3)return picks;
    }
   }return picks;
  }
  refreshHeroChoices(){if(!this.heroButtons)return;this.heroButtons.forEach(b=>{b.disabled=!this.heroPicks(b.dataset.heroChoice).length});if(this.heroMode!=='featured'&&[...this.heroGallery.children].some(n=>n.dataset.expire&&Date.now()>=Date.parse(n.dataset.expire)))this.paintHero(false)}
  paintHero(animate=false){
   const picks=this.heroPicks(this.heroMode);if(!picks.length){this.heroMode='featured';picks.push(...this.heroPicks('featured'))}
   this.heroGallery.getAnimations().forEach(a=>a.cancel());this.heroGallery.replaceChildren(...picks);
   this.heroButtons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.heroChoice===this.heroMode)));
   if(animate&&!matchMedia('(prefers-reduced-motion: reduce)').matches)this.heroGallery.animate([{opacity:.25},{opacity:1}],{duration:180,easing:'ease-out'});
   if(animate){const active=this.heroButtons.find(b=>b.dataset.heroChoice===this.heroMode);this.querySelector('[data-hero-announcement]').textContent=active.textContent}
  }

  today(){const second=Math.floor(Date.now()/1000);if(this.dateSecond===second)return this.dateValue;this.dateFormatter??=new Intl.DateTimeFormat('en-CA',{timeZone:'America/Los_Angeles',year:'numeric',month:'2-digit',day:'2-digit'});const p=this.dateFormatter.formatToParts(new Date());this.dateSecond=second;return this.dateValue=['year','month','day'].map(t=>p.find(v=>v.type===t).value).join('-')}
  active(s){return (!s.end||Date.now()<Date.parse(s.end))&&(!s.dates.length||s.dates.some(d=>d<=this.today()))}
  buildDays(){
   const today=this.today();if(this.builtDay===today)return;this.builtDay=today;
   const wrap=this.querySelector('[data-day-controls]');wrap.querySelectorAll('[data-generated]').forEach(b=>b.remove());
   const dates=[...new Set(this.sources.flatMap(s=>s.dates))].filter(d=>d<=today&&d!==today).sort().reverse();
   dates.forEach(d=>{const b=document.createElement('button');b.type='button';b.dataset.day=d;b.dataset.generated='true';const day=Math.round((Date.parse(d+'T12:00:00Z')-Date.parse('2026-09-03T12:00:00Z'))/86400000)+1;b.textContent=this.labels.day+' '+day+' · '+new Intl.DateTimeFormat('en-US',{month:'short',day:'numeric',timeZone:'UTC'}).format(new Date(d+'T12:00:00Z'));b.setAttribute('aria-pressed','false');wrap.append(b)});
   if(this.sources.some(s=>!s.dates.length)){const b=document.createElement('button');b.type='button';b.dataset.day='earlier';b.dataset.generated='true';b.textContent=this.labels.earlier;b.setAttribute('aria-pressed','false');wrap.append(b)}
  }
  readURL(){const q=new URL(location.href).searchParams;this.collectionOrder=['tonight','featured','final-hours'].includes(q.get('sale_edit'))?q.get('sale_edit'):q.get('sale_collection_order')==='bestselling'?'bestselling':'tonight';for(const k of Object.keys(this.state)){if(q.has('sale_'+k))this.state[k]=k==='low'?q.get('sale_'+k)==='true':q.get('sale_'+k)}if(this.collectionOrder==='final-hours'){if(!q.has('sale_layout'))this.state.layout='editorial';if(!q.has('sale_day'))this.state.day='all'}if(!['editorial','catalog'].includes(this.state.layout))this.state.layout='catalog';if(this.state.search.trim()){this.state.day='all';this.state.collection='';const u=new URL(location.href);u.searchParams.delete('sale_day');u.searchParams.delete('sale_collection');u.hash='';history.replaceState(null,'',u);}}
  writeURL(){const u=new URL(location.href);if(this.collectionOrder!=='bestselling')u.searchParams.set('sale_edit',this.collectionOrder);else u.searchParams.delete('sale_edit');if(this.collectionOrder==='bestselling')u.searchParams.set('sale_collection_order','bestselling');else u.searchParams.delete('sale_collection_order');for(const[k,v]of Object.entries(this.state)){if(v&&v!=='all'&&v!=='featured')u.searchParams.set('sale_'+k,v);else u.searchParams.delete('sale_'+k)}history.pushState(null,'',u);}
  track(action,extra={}){this.dispatchEvent(new CustomEvent('tomo:sale-interaction',{bubbles:true,detail:{action,layout:this.state.layout,...extra}}));}
  bind(){
   this.addEventListener('click',e=>{

    const edit=e.target.closest('[data-sale-edit]');if(edit){Object.assign(this.state,{day:'all',collection:'',category:'',brand:'',price:'',sort:'featured',search:'',low:false});this.browseExtra=0;const u=new URL(location.href);u.hash='';history.replaceState(null,'',u);const order=this.querySelector('[data-collection-order]');order.value=edit.dataset.saleEdit;order.dispatchEvent(new Event('change',{bubbles:true}));return}
    const railRetry=e.target.closest('[data-rail-retry]');if(railRetry){const rail=railRetry.closest('[data-sale-rail]');delete rail.dataset.railError;this.railRequests.delete(rail.dataset.source);this.queueRail(rail,true);return}const layout=e.target.closest('[data-layout-button]');if(layout){this.state.layout=layout.dataset.layoutButton;this.limit=24;this.apply();this.track('layout');return}
    const day=e.target.closest('[data-day]');if(day){this.state.day=day.dataset.day;this.state.collection='';this.limit=24;this.apply();this.track('day',{day:this.state.day});return}
    const remove=e.target.closest('[data-remove-filter]');if(remove){const key=remove.dataset.removeFilter;this.state[key]=key==='day'?'all':key==='sort'?'featured':key==='low'?false:'';this.limit=24;if(key==='collection'){const u=new URL(location.href);u.hash='';history.replaceState(null,'',u)}this.apply();const next=this.querySelector('[data-active-filters] button');(next||this.querySelector('[data-clear]')).focus();return}
    const clear=e.target.closest('[data-clear]');if(clear){for(const k of ['category','brand','price','search','collection'])this.state[k]='';this.state.low=false;this.state.sort='featured';this.state.day='all';this.limit=24;this.apply();return}
    if(e.target.closest('[data-reset-collection]')){this.state.collection='';this.apply();return}
    if(e.target.closest('[data-load]')){this.loadMore();return}
    if(e.target.closest('[data-retry]')){this.sources.forEach(s=>s.error=false);this.rails.forEach(r=>{delete r.dataset.railError});this.railRequests.clear();if(!this.seedBusy)this.seedPromise=null;this.ensureSeeds().then(()=>{if(!this.groupedBrowsing())this.startIndex()});return}
    const link=e.target.closest('[data-collection-link]');if(link){e.preventDefault();this.goCollection(link.dataset.collectionLink);return}
    const dead=e.target.closest('.sale-deadline');if(dead){e.preventDefault();this.goCollection('saturday_02');return}
    const slide=e.target.closest('[data-today-slider-prev],[data-today-slider-next]');if(slide){const row=slide.closest('.tomo-edit__collection').querySelector('[data-today-slider]');row.scrollBy({left:(slide.hasAttribute('data-today-slider-prev')?-1:1)*row.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});return}
    const prod=e.target.closest('[data-sale-card] a');if(prod)this.track('product_click',{product:prod.closest('[data-sale-card]').dataset.campaignProductId});
   });
   this.controls.forEach(c=>c.addEventListener(c.type==='search'?'input':'change',()=>{clearTimeout(this.debounce);this.debounce=setTimeout(()=>{this.state[c.dataset.filter]=c.type==='checkbox'?c.checked:c.value;if(c.dataset.filter==='sort')this.state.layout='catalog';if(c.dataset.filter==='search'&&c.value.trim()){this.state.day='all';this.state.collection='';const u=new URL(location.href);u.hash='';history.replaceState(null,'',u);}this.limit=24;this.apply();this.track('filter',{filter:c.dataset.filter})},c.type==='search'?180:0)}));
   this.pop=()=>{this.state={layout:'catalog',day:'all',category:'',brand:'',price:'',sort:'featured',search:'',low:false,collection:''};this.readURL();this.apply(false);this.handleHash()};window.addEventListener('popstate',this.pop);
   this.scrollHandler=()=>{if(this.state.layout==='catalog'&&!this.seedBusy&&!this.busy&&scrollY>100&&!this.querySelector('[data-load]').hidden&&this.querySelector('[data-load]').getBoundingClientRect().top<innerHeight+400)this.loadMore()};window.addEventListener('scroll',this.scrollHandler,{passive:true});this.hashHandler=()=>this.handleHash();window.addEventListener('hashchange',this.hashHandler);
  }
  dayMatches(s){let d=this.state.day;if(d==='today')d=this.today();return d==='all'||(this.state.day==='today'&&this.todayFallback)||(d==='earlier'&&!s.dates.length)||s.dates.includes(d)}
  async revealCollection(id,write=true){
   const source=this.sources.find(s=>s.id===id);if(!source||!this.active(source))return;
   if(this.collectionOrder==='final-hours'&&!this.finalHourOrder.includes(id))this.collectionOrder='featured';
   const token=this.revealToken=(this.revealToken||0)+1;
   Object.assign(this.state,{day:'all',category:'',brand:'',search:'',price:'',low:false,sort:'featured',collection:this.state.layout==='catalog'?id:''});
   this.apply(write);const u=new URL(location.href);u.hash='campaign-collection-'+id;history.replaceState(null,'',u);
   await this.ensureSource(source);
   if(token!==this.revealToken||!this.isConnected)return;
   this.apply(false);
   const target=this.state.layout==='catalog'?this.querySelector('#today-deals'):this.rails.find(r=>r.dataset.id===id);
   target?.scrollIntoView({block:'start',behavior:'auto'});
  }
  goCollection(id){this.revealCollection(id);this.track('collection',{collection:id})}
  handleHash(){
   const h=location.hash.slice(1);if(this.state.search.trim())return;
   if(h.startsWith('campaign-collection-')){this.revealCollection(h.slice('campaign-collection-'.length),false);return}
   const groups={'new-additions':'earlier_new_','more-heading':'earlier_more_','ending-soon':'earlier_ending_','favorites-heading':'earlier_daily_'};
   if(groups[h]){const source=this.sources.find(s=>s.id.startsWith(groups[h])&&this.active(s));if(source)this.revealCollection(source.id,false)}
  }
  addCard(node,source){if(!(Number(node.dataset.salePercent)>0||Number(node.dataset.saleSavings)>0||(source.id==='friday_07'&&!/compression leggings|workweek essentials|everyday rotation/i.test(node.dataset.saleTitle||'')))){node.remove();return false}const id=node.dataset.campaignProductId;if(this.cards.has(id)){const c=this.cards.get(id);c.sources.add(source.id);c.order=Math.min(c.order,source.rank*100000+source.position++);return}this.cards.set(id,{id,node:node.cloneNode(true),sources:new Set([source.id]),price:Number(node.dataset.salePrice),percent:Number(node.dataset.salePercent),saving:Number(node.dataset.saleSavings),brand:node.dataset.saleBrand||({'sunday_explore_scientific':'Explore Scientific','sunday_big_blanket':'Big Blanket Co.','sunday_dragon':'Dragon Glassware','sunday_wirsh':'Wirsh','sunday_windhorse':'Windhorse','sunday_minus33':'Minus33','sunday_lincove':'Lincove','saturday_02':'Roborock','saturday_03':'Heavys','saturday_04':'WPPO','saturday_05':'Mini Museum','friday_01':'Sunday Citizen','earlier_daily_paul_rich':'Paul Rich','earlier_ending_uncommon':'Uncommon Carry','earlier_more_astro':'Astro Gallery','earlier_new_aeropress':'AeroPress','earlier_daily_ancient':'Ancient Inspired'}[source.id]||''),title:node.dataset.saleTitle||'',low:node.dataset.saleLow==='true',order:source.rank*100000+source.position++});}
  matches(c,eligible){const sources=(eligible||this.sources.filter(s=>this.active(s)&&this.dayMatches(s))).filter(s=>c.sources.has(s.id));return sources.some(s=>(!this.state.collection||s.id===this.state.collection)&&(!this.state.category||s.category===this.state.category))&&(!this.state.brand||c.brand===this.state.brand)&&(!this.state.price||c.price<Number(this.state.price))&&(!this.state.low||c.low)&&(!this.state.search||(c.title+' '+c.brand).toLowerCase().includes(this.state.search.toLowerCase()))}
  results(){const eligible=this.sources.filter(s=>this.active(s)&&this.dayMatches(s));const seedIds=this.seedIds();const seedSet=new Set(seedIds);const c=[...this.cards.values()].filter(c=>this.matches(c,eligible)&&(!this.groupedBrowsing()||seedSet.has(c.id)));const sort=this.state.sort;if(sort==='price-asc')c.sort((a,b)=>a.price-b.price);else if(sort==='price-desc')c.sort((a,b)=>b.price-a.price);else if(sort==='discount')c.sort((a,b)=>b.percent-a.percent);else if(sort==='bestselling')c.sort((a,b)=>(this.bestsellerRanks[a.id]??999)-(this.bestsellerRanks[b.id]??999)||a.order-b.order);else if(sort==='savings')c.sort((a,b)=>b.saving-a.saving);else {const todaySources=new Set(eligible.filter(s=>s.dates.includes(this.today())).map(s=>s.id));const priority=c=>[...c.sources].some(id=>todaySources.has(id))?0:1;c.sort((a,b)=>{const ai=seedIds.indexOf(a.id),bi=seedIds.indexOf(b.id);return (ai<0)-(bi<0)||(ai>=0&&bi>=0?ai-bi:priority(a)-priority(b)||a.order-b.order)})}return c}
  apply(write=true){
   const designerFeature=this.querySelector('[data-designer-feature]');if(designerFeature)designerFeature.hidden=this.collectionOrder!=='tonight'||this.hasFilters();
   this.querySelector('[data-bestseller-note]').hidden=this.state.sort!=='bestselling';
   if(this.state.search.trim()){this.state.day='all';this.state.collection='';}this.dataset.layout=this.state.layout;this.dataset.activeLayout=this.state.layout;const catalog=this.state.layout==='catalog';this.querySelector('[data-collection-order-wrap]').hidden=true;this.querySelector('[data-collection-order]').value=this.collectionOrder;this.querySelector('[data-editorial-view]').hidden=catalog;this.querySelector('[data-catalog-view]').hidden=!catalog;this.querySelector('[data-catalog-controls]').hidden=!catalog;
   this.querySelectorAll('[data-sale-edit]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.saleEdit===this.collectionOrder)));
   this.querySelectorAll('[data-layout-button]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.layoutButton===this.state.layout)));this.querySelectorAll('[data-day]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.day===this.state.day)));
   this.controls.forEach(c=>{if(c.type==='checkbox')c.checked=this.state[c.dataset.filter];else c.value=this.state[c.dataset.filter]});
   const todayEmpty=this.state.day==='today'&&!this.sources.some(s=>this.active(s)&&s.dates.includes(this.today()));this.todayFallback=todayEmpty;this.querySelector('[data-day-notice]').hidden=!todayEmpty;
   let n=0;this.rails.forEach(rail=>{const s=this.sources.find(s=>s.id===rail.dataset.id);const show=this.active(s)&&(this.dayMatches(s)||todayEmpty)&&(!!rail.querySelector('[data-sale-card]')||!!rail.querySelector('[data-rail-pending]'));rail.hidden=!show;if(show)n++;this.querySelectorAll('[data-collection-link="'+s.id+'"]').forEach(link=>{link.hidden=!this.active(s);const today=this.active(s)&&s.dates.includes(this.today());link.classList.toggle('sale-collection-today',today);let badge=link.querySelector('[data-today-badge]');if(today&&!badge){badge=document.createElement('span');badge.dataset.todayBadge='';badge.textContent=this.labels.today;link.append(badge)}if(!today&&badge)badge.remove();link.setAttribute('aria-current',String(this.state.collection===s.id))})});
   this.querySelectorAll('[data-editorial-view] > [data-spotlight]').forEach(s=>s.hidden=this.state.day!=='all'||this.collectionOrder==='final-hours');
   this.querySelectorAll('.sale-deadline[data-expire],.sale-hero__item[data-expire]').forEach(e=>e.hidden=Date.now()>=Date.parse(e.dataset.expire));
   this.querySelector('[data-results-status]').textContent=n+' '+this.labels.count;
   const chip=this.querySelector('[data-reset-collection]');chip.hidden=!this.state.collection;chip.textContent=(this.sources.find(s=>s.id===this.state.collection)?.label||'')+' ×';
   this.querySelector('[data-search-scope]').hidden=!this.state.search.trim();if(catalog){this.refreshBrands();this.renderGrid();this.ensureSeeds().then(()=>{if(!this.groupedBrowsing())this.startIndex()})}else{this.ensureSeeds();this.rails.filter(r=>!r.hidden&&r.getBoundingClientRect().top<innerHeight+500&&r.getBoundingClientRect().bottom>-500).forEach(r=>this.queueRail(r));}
   if(!catalog)this.orderCollections();this.placeWeekendProducts();this.renderActiveFilters();if(write)this.writeURL();
  }
  orderCollections(){
   const wrap=this.querySelector('[data-editorial-view]');
   if(this.collectionOrder==='featured'){this.editorialHome.forEach(el=>wrap.append(el));this.placeWeekendProducts();return}
   if(this.collectionOrder==='tonight'){this.eveningSources().forEach(source=>{const rail=this.rails.find(r=>r.dataset.id===source.id);if(rail)wrap.append(rail)});return}
   if(this.collectionOrder==='final-hours'){this.finalHourAllSources().forEach(source=>{const rail=this.rails.find(r=>r.dataset.id===source.id);if(rail)wrap.append(rail)});return}
   this.rails.slice().sort((a,b)=>(this.collectionRanks[b.dataset.id]?.[this.collectionOrder]||0)-(this.collectionRanks[a.dataset.id]?.[this.collectionOrder]||0)||this.sources.find(s=>s.id===a.dataset.id).rank-this.sources.find(s=>s.id===b.dataset.id).rank).forEach(rail=>wrap.append(rail));
  }
  placeWeekendProducts(){
   if(!this.weekendProducts)return;
   const plain=this.groupedBrowsing()&&!this.hasFilters()&&this.collectionOrder==='featured';
   this.weekendProducts.hidden=!plain;
   if(!plain){this.weekendHome.append(this.weekendProducts);return}
   const monday=this.sources.filter(s=>s.dates.includes('2026-09-07'));
   const candidates=this.state.layout==='catalog'?[...this.grid.querySelectorAll('[data-catalog-collection]')]:this.rails.filter(r=>!r.hidden);
   const final=candidates.filter(el=>monday.some(s=>s.id===(el.dataset.catalogCollection||el.dataset.id))).pop();
   if(final)final.after(this.weekendProducts);else this.weekendHome.append(this.weekendProducts);
  }
  renderActiveFilters(){
   const wrap=this.querySelector('[data-active-filters]');if(!wrap)return;const buttons=[];
   for(const key of ['day','collection','search','category','brand','price','low','sort']){
    const value=this.state[key];if(!value||key==='day'&&value==='all'||key==='sort'&&value==='featured')continue;
    let label=String(value);const control=this.controls.find(c=>c.dataset.filter===key);
    if(key==='day')label=[...this.querySelectorAll('[data-day]')].find(b=>b.dataset.day===value)?.textContent||value;
    else if(key==='collection')label=this.sources.find(s=>s.id===value)?.label||value;
    else if(control?.tagName==='SELECT')label=control.selectedOptions[0]?.textContent||value;
    else if(key==='low')label=control?.closest('label')?.textContent.trim()||value;
    const button=document.createElement('button');button.type='button';button.dataset.removeFilter=key;button.textContent=label+' ×';button.setAttribute('aria-label',(this.labels.removeFilter||'Remove filter')+': '+label);buttons.push(button);
   }
   wrap.replaceChildren(...buttons);wrap.hidden=!buttons.length;
  }
  refreshBrands(){const select=this.querySelector('[data-filter=brand]');const brands=[...new Set([...this.cards.values()].map(c=>c.brand).filter(Boolean))].sort();for(const name of brands){if(![...select.options].some(o=>o.value===name))select.add(new Option(name,name))}select.value=this.state.brand;}
  cloneCard(c,i){const node=c.node.cloneNode(true);const ids=new Map();node.querySelectorAll('[id]').forEach(el=>{const old=el.id;const value=old+'-sale-grid-'+i;ids.set(old,value);el.id=value});node.querySelectorAll('[for],[aria-controls],[aria-labelledby]').forEach(el=>{for(const attr of ['for','aria-controls','aria-labelledby']){const old=el.getAttribute(attr);if(old)el.setAttribute(attr,old.split(' ').map(v=>ids.get(v)||v).join(' '))}});return node}
  prepareProductRail(row,source,key){
   const cards=[...row.querySelectorAll('[data-sale-card]')];if(!cards.length)return;
   const perPage=matchMedia('(max-width:749px)').matches?2:4;const signature=perPage+'|'+cards.map(c=>c.dataset.campaignProductId).join('|');if(row.dataset.productRailSignature===signature)return;
   row.dataset.productRailSignature=signature;row.classList.add('sale-product-rail');row.id='sale-product-rail-'+this.dataset.sectionId+'-'+key;row.setAttribute('role','region');row.setAttribute('aria-label',source.label);row.tabIndex=0;
   const pages=[];for(let i=0;i<cards.length;i+=perPage){const page=document.createElement('div');page.className='sale-product-page';page.setAttribute('role','list');cards.slice(i,i+perPage).forEach(card=>page.append(card));pages.push(page)}row.replaceChildren(...pages);
   let nav=row.nextElementSibling;if(!nav?.classList.contains('sale-rail-navigation')){nav=document.createElement('div');nav.className='sale-rail-navigation';row.after(nav)}nav.replaceChildren();
   const previous=document.createElement('button'),next=document.createElement('button'),range=document.createElement('span');previous.type=next.type='button';previous.textContent='←';next.textContent='→';previous.setAttribute('aria-label',this.labels.previousProducts);next.setAttribute('aria-label',this.labels.nextProducts);previous.setAttribute('aria-controls',row.id);next.setAttribute('aria-controls',row.id);range.className='sale-rail-range';range.setAttribute('aria-live','polite');range.setAttribute('aria-atomic','true');nav.append(previous,range,next);
   let pageIndex=0;const current=()=>Math.max(0,Math.min(pages.length-1,Math.round(Math.abs(row.scrollLeft)/(row.clientWidth||1))));
   const update=()=>{const index=current();pageIndex=index;const height=pages[index]?.offsetHeight;if(height&&row.style.height!==height+'px')row.style.height=height+'px';previous.setAttribute('aria-disabled',String(index===0));next.setAttribute('aria-disabled',String(index===pages.length-1));range.textContent=this.labels.productRange.replace('[start]',index*perPage+1).replace('[end]',Math.min((index+1)*perPage,cards.length)).replace('[total]',cards.length)};
   const move=index=>{const target=Math.max(0,Math.min(pages.length-1,index));row.scrollTo({left:(getComputedStyle(row).direction==='rtl'?-1:1)*target*row.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'})};
   previous.onclick=()=>move(current()-1);next.onclick=()=>move(current()+1);row.onscroll=update;row.saleRailResize=()=>{const width=row.clientWidth;if(!width||row.saleRailLastWidth===width)return;row.saleRailLastWidth=width;if((matchMedia('(max-width:749px)').matches?2:4)!==perPage){row.style.height='';this.prepareProductRail(row,source,key);return}row.scrollTo({left:(getComputedStyle(row).direction==='rtl'?-1:1)*pageIndex*row.clientWidth,behavior:'instant'});update()};if(!this.productRailObserver)this.productRailObserver=new ResizeObserver(entries=>entries.forEach(({target})=>{if(target.isConnected)target.saleRailResize?.();else this.productRailObserver.unobserve(target)}));this.productRailObserver.observe(row);row.querySelectorAll('img').forEach(img=>{if(!img.complete)img.addEventListener('load',update,{once:true})});row.onkeydown=e=>{if(e.target!==row)return;const step=getComputedStyle(row).direction==='rtl'?-1:1;const target=e.key==='ArrowRight'?current()+step:e.key==='ArrowLeft'?current()-step:e.key==='Home'?0:e.key==='End'?pages.length-1:null;if(target!==null){e.preventDefault();move(target)}};update();
  }
  prepareEditorialRail(rail,source){const row=rail.querySelector('.tomo-edit__products');if(!row)return;rail.querySelector('.tomo-edit__slider-controls')?.remove();this.prepareProductRail(row,source,'editorial-'+source.id)}
  groupedBrowsing(){return !this.state.search.trim()&&!this.state.brand&&!this.state.price&&!this.state.low&&this.state.sort==='featured'}
  collectionGroups(cards){const ids=new Set(cards.map(c=>c.id));return this.browseSources().map(source=>({source,cards:source.seeds.map(id=>this.cards.get(id)).filter(c=>c&&ids.has(c.id))})).filter(group=>group.cards.length)}
  collectionLink(source){const a=document.createElement('a');a.className='sale-collection-cta';a.href=source.url;a.textContent=this.labels.shopCollection+' →';a.setAttribute('aria-label',this.labels.shopCollection+': '+source.label);return a}
  renderGrid(){this.refreshHeroChoices();if(this.state.layout!=='catalog')return;this.indexDone=this.indexSources().every(s=>s.done);const results=this.results();const visible=this.groupedBrowsing()?results:results.slice(0,this.limit);const signature=JSON.stringify([this.groupedBrowsing()?this.browseSources().map(s=>[s.id,s.seeds]):null,visible.map(c=>c.id),this.state.search,this.state.brand,this.state.collection,this.state.low,this.state.category,this.state.sort,this.state.price,this.state.day]);if(signature!==this.gridSignature&&!this.grid.matches(':focus-within')){const fragment=document.createDocumentFragment();const grouped=this.groupedBrowsing();this.grid.classList.toggle('sale-grid--collections',grouped);this.grid.setAttribute('role',grouped?'region':'list');if(grouped){this.collectionGroups(visible).forEach(({source,cards})=>{const group=document.createElement('section');group.className='sale-catalog-collection';group.dataset.catalogCollection=source.id;const rail=this.rails.find(r=>r.dataset.id===source.id);const heading=rail?.querySelector('.tomo-edit__collection-head')?.cloneNode(true);if(heading){heading.querySelector('.tomo-edit__slider-controls')?.remove();heading.querySelectorAll('.sale-collection-cta').forEach(a=>a.remove());heading.querySelectorAll('[id]').forEach(el=>el.id+='-catalog');const title=heading.querySelector('h3');if(title)group.setAttribute('aria-labelledby',title.id);heading.append(this.collectionLink(source));group.append(heading)}const row=document.createElement('div');row.className='sale-grid';row.setAttribute('role','list');cards.forEach(c=>row.append(this.cloneCard(c,source.id+'-'+source.seeds.indexOf(c.id))));group.append(row);this.prepareProductRail(row,source,'catalog-'+source.id);const footer=document.createElement('div');footer.className='sale-collection-footer';footer.append(this.collectionLink(source));group.append(footer);fragment.append(group)})}else{visible.forEach((c,i)=>fragment.append(this.cloneCard(c,i)))}this.grid.querySelectorAll('.sale-product-rail').forEach(row=>this.productRailObserver?.unobserve(row));if(this.weekendProducts&&this.grid.contains(this.weekendProducts))this.weekendHome.append(this.weekendProducts);this.grid.replaceChildren(fragment);this.gridSignature=signature;this.placeWeekendProducts();}this.querySelector('[data-empty]').hidden=results.length>0||this.busy||this.seedBusy||(!this.groupedBrowsing()&&this.indexSources().some(s=>!s.done&&!s.error));this.querySelector('[data-results-status]').textContent=this.groupedBrowsing()?this.collectionGroups(visible).length+' '+this.labels.count+' · '+this.collectionGroups(visible).reduce((n,g)=>n+g.cards.length,0)+' '+this.labels.featuredProducts:results.length+' '+this.labels.found+' · '+visible.length+' '+this.labels.shown;this.querySelector('[data-load]').hidden=this.groupedBrowsing()?!this.hasUnshownDeals():visible.length>=results.length&&this.indexDone;this.querySelector('[data-load]').disabled=!!(this.seedBusy||this.busy);this.querySelector('[data-load]').textContent=this.groupedBrowsing()?this.labels.loadCollections:this.labels.load;this.querySelector('[data-load-status]').textContent=this.busy||this.seedBusy?(this.groupedBrowsing()?this.labels.findingCollections:this.labels.finding):this.sources.some(s=>s.error)||this.rails.some(r=>r.dataset.railError)?this.labels.error:'';this.querySelector('[data-retry]').hidden=!(this.sources.some(s=>s.error)||this.rails.some(r=>r.dataset.railError));}
  queueRail(rail,priority=false){if(this.seedBusy&&this.seedSources().some(s=>s.id===rail.dataset.id))return;if(!rail.querySelector('[data-rail-pending]')||rail.dataset.railLoading||rail.dataset.railError)return;if(this.railQueue.includes(rail)){if(priority){this.railQueue=this.railQueue.filter(r=>r!==rail);this.railQueue.unshift(rail)}}else if(priority)this.railQueue.unshift(rail);else this.railQueue.push(rail);this.drainRails()}
  async drainRails(){while(this.railWorkers<2&&this.railQueue.length&&this.isConnected){const rail=this.railQueue.shift();if(rail.hidden)continue;this.railWorkers++;rail.dataset.railLoading='true';this.ensureSource(this.sources.find(s=>s.id===rail.dataset.id)).finally(()=>{delete rail.dataset.railLoading;this.railWorkers--;this.drainRails()})}}
  async fetchText(url){const controller=new AbortController();this.requests.add(controller);const timer=setTimeout(()=>controller.abort(),20000);try{const response=await fetch(url,{signal:controller.signal,credentials:'same-origin'});if(!response.ok)throw Error('HTTP '+response.status);return await response.text()}finally{clearTimeout(timer);this.requests.delete(controller)}}
  themeURL(path,view){const url=new URL(path,location.origin);url.searchParams.set('view',view);const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);return url}
  async loadRail(rail){const pending=rail.querySelector('[data-rail-pending]');const status=rail.querySelector('[data-rail-status]');const retry=rail.querySelector('[data-rail-retry]');if(status)status.textContent=this.labels.finding;if(retry)retry.hidden=true;try{const key=rail.dataset.source;if(!this.railRequests.has(key))this.railRequests.set(key,this.fetchText(this.themeURL(key,'tomo-sale-rail')).catch(e=>{this.railRequests.delete(key);throw e}));const doc=new DOMParser().parseFromString(await this.railRequests.get(key),'text/html');const feed=doc.querySelector('[data-sale-rail-feed]');if(!feed||feed.dataset.themeId!==this.dataset.themeId)throw Error('rail theme mismatch');const response=[...feed.querySelectorAll('[data-sale-rail-response]')].find(r=>r.dataset.saleRailResponse===rail.dataset.id);if(!response)throw Error('rail missing');if(!rail.querySelector('[data-rail-pending]'))return;const source=this.sources.find(s=>s.id===rail.dataset.id);response.querySelectorAll('[data-sale-card]').forEach(c=>{this.addCard(c,source);if(this.cards.has(c.dataset.campaignProductId)&&!source.seeds.includes(c.dataset.campaignProductId)&&source.seeds.length<8)source.seeds.push(c.dataset.campaignProductId)});rail.replaceChildren(...response.childNodes);if(!rail.querySelector('[data-sale-card]'))rail.hidden=true;this.prepareEditorialRail(rail,source);this.railObserver.unobserve(rail);this.renderGrid()}catch(e){rail.dataset.railError='true';if(status)status.textContent=this.labels.error;if(retry)retry.hidden=false}}
  hasFilters(){return !!(this.state.search.trim()||this.state.collection||this.state.category||this.state.brand||this.state.price||this.state.low||this.state.sort!=='featured'||this.state.day!=='all')}
  hasUnshownDeals(){return this.groupedBrowsing()&&!this.hasFilters()&&this.browseSources().length<this.indexSources().length}
  finalHourSources(){return (this.finalHourOrder||[]).map(id=>this.sources.find(s=>s.id===id)).filter(s=>s&&this.active(s))}
  finalHourAllSources(){const first=this.finalHourSources();const rest=this.sources.filter(s=>this.active(s)&&!first.includes(s)).sort((a,b)=>(this.collectionRanks?.[b.id]?.revenue||0)-(this.collectionRanks?.[a.id]?.revenue||0)||a.rank-b.rank);return [...first,...rest]}
  eveningSources(){const first=(this.eveningOrder||[]).map(id=>this.sources.find(s=>s.id===id)).filter(s=>s&&this.active(s));const rest=this.finalHourAllSources().filter(s=>!first.includes(s));return [...first,...rest]}
  seedSources(){if(this.collectionOrder==='tonight')return this.eveningSources().slice(0,this.eveningOrder.length);if(this.collectionOrder==='final-hours')return this.finalHourSources();const active=this.sources.filter(s=>this.active(s));const date=active.some(s=>s.dates.includes(this.today()))?this.today():active.flatMap(s=>s.dates).filter(d=>d<=this.today()).sort().pop();return active.filter(s=>date?s.dates.includes(date):true)}
  seedIds(){return [...new Set(this.browseSources().flatMap(s=>s.seeds))]}
  browseSources(){const eligible=this.indexSources();if(this.collectionOrder==='tonight'&&this.groupedBrowsing()&&!this.hasFilters())return this.eveningSources().filter(s=>eligible.includes(s)).slice(0,this.eveningOrder.length+this.browseExtra);if(this.collectionOrder==='final-hours'&&this.groupedBrowsing()&&!this.state.collection)return this.finalHourAllSources().filter(s=>eligible.includes(s)).slice(0,this.finalHourSources().filter(s=>eligible.includes(s)).length+this.browseExtra);if(this.hasFilters())return eligible;const initial=this.seedSources().filter(s=>eligible.includes(s));return [...initial,...eligible.filter(s=>!initial.includes(s))].slice(0,initial.length+this.browseExtra)}
  async loadMore(){if(this.seedBusy||this.busy)return;if(this.groupedBrowsing()){this.browseExtra+=3;await this.ensureSeeds()}else{this.limit+=24;this.renderGrid();this.startIndex()}this.track('load_more')}
  ensureSeeds(){const wanted=this.groupedBrowsing()?this.browseSources():this.seedSources();const key=wanted.map(s=>s.id).join('|');if(this.seedPromise&&this.seedKey===key)return this.seedPromise;this.seedKey=key;this.seedBusy=true;const promise=(async()=>{const pending=[...wanted];const worker=async()=>{while(pending.length&&this.isConnected){await this.ensureSource(pending.shift());this.refreshBrands();this.renderGrid()}};await Promise.all([worker(),worker()]);if(this.seedPromise===promise){this.seedBusy=false;this.renderGrid()}})();this.seedPromise=promise;return promise}
  ensureSource(source){if(this.sourceTasks.has(source.id))return this.sourceTasks.get(source.id);const task=(async()=>{const rail=this.rails.find(r=>r.dataset.id===source.id);if(rail.querySelector('[data-rail-pending]'))await this.loadRail(rail);if(rail.dataset.railError)return;for(const card of this.cards.values()){if(card.sources.has(source.id)&&!source.seeds.includes(card.id)&&source.seeds.length<8)source.seeds.push(card.id)}try{while(source.seeds.length<8&&!source.done&&!source.error){await this.fetchPage(source);for(const card of this.cards.values()){if(card.sources.has(source.id)&&!source.seeds.includes(card.id)&&source.seeds.length<8)source.seeds.push(card.id)}}}catch(e){source.error=true}const row=rail.querySelector('.tomo-edit__products');if(row){const present=new Set([...row.querySelectorAll('[data-sale-card]')].map(c=>c.dataset.campaignProductId));source.seeds.forEach(id=>{if(!present.has(id))row.append(this.cards.get(id).node.cloneNode(true))})}this.prepareEditorialRail(rail,source);if(source.seeds.length)rail.hidden=!(this.active(source)&&this.dayMatches(source));})();this.sourceTasks.set(source.id,task);task.finally(()=>this.sourceTasks.delete(source.id));return task}

  indexSources(){return this.sources.filter(s=>this.active(s)&&this.dayMatches(s)&&(!this.state.collection||s.id===this.state.collection)&&(!this.state.category||s.category===this.state.category))}
  async fetchPage(source){if(source.pageTask)return source.pageTask;source.pageTask=this.fetchSourcePage(source);try{return await source.pageTask}finally{source.pageTask=null}}
  async fetchSourcePage(source){const doc=new DOMParser().parseFromString(await this.fetchText(this.themeURL(source.next,'tomo-sale-feed')),'text/html');const feed=doc.querySelector('[data-sale-feed]');if(!feed||feed.dataset.themeId!==this.dataset.themeId)throw Error('feed markup');feed.querySelectorAll('[data-sale-card]').forEach(c=>this.addCard(c,source));const next=feed.dataset.next;source.done=!next;source.next=next||'';source.error=false}
  async startIndex(){if(this.busy||this.groupedBrowsing())return;this.busy=true;await this.ensureSeeds();this.renderGrid();
   const worker=async()=>{while(this.isConnected&&this.state.layout==='catalog'&&!this.groupedBrowsing()){const source=this.indexSources().find(s=>!s.done&&!s.error&&!s.inFlight);if(!source)break;source.inFlight=true;try{await this.fetchPage(source);this.refreshBrands();if(!this.renderQueued){this.renderQueued=true;setTimeout(()=>{this.renderQueued=false;this.renderGrid()},250)}}catch(e){if(this.isConnected)source.error=true}finally{source.inFlight=false}}};
   await Promise.all([worker(),worker()]);this.busy=false;this.indexDone=this.indexSources().every(s=>s.done);this.renderGrid();this.track('catalog_ready',{count:this.cards.size,complete:this.indexDone});
  }

 }
 customElements.define('tomo-sale-discovery',SaleDiscovery);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tomo-under100"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('u100-category-nav')) {
  class U100CategoryNav extends HTMLElement {
    connectedCallback() {
      this.page = this.closest('.u100');
      this.details = this.querySelector('[data-u100-nav-selector]');
      this.currentLabel = this.querySelector('[data-u100-current-label]');
      this.links = [...this.querySelectorAll('[data-u100-category-link]')];
      this.sections = [...this.page.querySelectorAll('[data-u100-category-section]')];
      this.setupStickyOffset();
      if (!this.links.length || !this.sections.length) return;
      this.setCurrent = id => {
        const currentLink = this.links.find(link => link.dataset.u100CategoryId === id);
        if (!currentLink) return;
        this.links.forEach(link => {
          if (link.dataset.u100CategoryId === id) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
        if (this.currentLabel) this.currentLabel.textContent = currentLink.textContent.trim();
      };
      this.setFromHash = () => {
        const target = document.getElementById(location.hash.slice(1));
        const section = target?.closest('[data-u100-category-section]');
        if (section) this.setCurrent(section.dataset.u100CategoryId);
      };
      this.handleClick = event => {
        const link = event.target.closest('[data-u100-category-link]');
        if (!link || !this.contains(link)) return;
        this.setCurrent(link.dataset.u100CategoryId);
        if (this.details?.contains(link)) this.details.open = false;
      };
      this.addEventListener('click', this.handleClick);
      window.addEventListener('hashchange', this.setFromHash);
      this.setCurrent(this.links[0].dataset.u100CategoryId);
      this.setFromHash();
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          const visible = entries.filter(entry => entry.isIntersecting);
          if (!visible.length) return;
          visible.sort((a, b) => Math.abs(a.boundingClientRect.top) - Math.abs(b.boundingClientRect.top));
          this.setCurrent(visible[0].target.dataset.u100CategoryId);
        }, { rootMargin: '-15% 0px -70% 0px', threshold: 0 });
        this.sections.forEach(section => this.observer.observe(section));
      }
    }
    setupStickyOffset() {
      this.header = document.querySelector('.headerGroup') || document.querySelector('header-component');
      this.clock = document.querySelector('.tomo-daily-clock');
      this.nav = this.querySelector('.u100-nav');
      this.updateStickyOffset = () => {
        if (this.stickyFrame) return;
        this.stickyFrame = requestAnimationFrame(() => {
          this.stickyFrame = 0;
          if (!this.isConnected) return;
          const fixedBottom = element => {
            if (!element) return 0;
            const rect = element.getBoundingClientRect();
            const position = getComputedStyle(element).position;
            if (position !== 'fixed' && position !== 'sticky') return 0;
            if (rect.bottom <= 0 || rect.top >= innerHeight) return 0;
            return Math.max(0, rect.bottom);
          };
          let top = fixedBottom(this.header);
          if (this.clock && !this.clock.hidden) {
            const clockBottom = fixedBottom(this.clock);
            if (clockBottom) top = Math.max(top, clockBottom);
            else if (this.clock.classList.contains('tomo-daily-clock--bar')) top += this.clock.getBoundingClientRect().height;
          }
          const mobile = matchMedia('(max-width: 749px)').matches;
          const navHeight = mobile ? this.nav?.getBoundingClientRect().height || 0 : 0;
          if (!mobile) this.page.style.removeProperty('--u100-sticky-top');
          else this.page.style.setProperty('--u100-sticky-top', `${Math.ceil(top)}px`);
          this.page.style.setProperty('--u100-anchor-offset', `${Math.ceil(top + navHeight + 12)}px`);
        });
      };
      this.stickyResize = new ResizeObserver(this.updateStickyOffset);
      if (this.header) this.stickyResize.observe(this.header);
      if (this.clock) this.stickyResize.observe(this.clock);
      if (this.nav) this.stickyResize.observe(this.nav);
      if (this.clock) {
        this.stickyMutation = new MutationObserver(this.updateStickyOffset);
        this.stickyMutation.observe(this.clock, { attributes: true, attributeFilter: ['class', 'hidden'] });
      }
      this.updateStickyOffset();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.stickyFrame);
      this.observer?.disconnect();
      this.stickyResize?.disconnect();
      this.stickyMutation?.disconnect();
      this.removeEventListener('click', this.handleClick);
      window.removeEventListener('hashchange', this.setFromHash);
      this.page?.style.removeProperty('--u100-sticky-top');
      this.page?.style.removeProperty('--u100-anchor-offset');
    }
  }
  customElements.define('u100-category-nav', U100CategoryNav);
}

  } catch(e) { console.error(e); }
})();
})();
